/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */

/**
 * Current account state for smart charging
 */
export type SmartChargingState =
  (typeof SmartChargingState)[keyof typeof SmartChargingState]

export const SmartChargingState = {
  notEnrolled: "notEnrolled",
  enrolled: "enrolled",
} as const
